import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';
import { SpeedReadingFooterModule } from '../speed-reading-footer/speed-reading-footer.module';
import { HideOnNarrowWidthDirective } from '@pages/games/game/game-instance/hide-on-narrow-width.directive';
import { DefaultImageModule } from '@shared/directives/default-image.module';
import { GAME_OPERATOR_TOKEN } from '@games/core/common';
import { GAME_TOKEN } from '@games/core/game';
import { Theme } from '@games/core/operator/types';

@Component({
  selector: 'ms-text-container',
  imports: [CommonModule, SpeedReadingFooterModule, HideOnNarrowWidthDirective, DefaultImageModule],
  templateUrl: './text-container.component.html',
  styleUrls: ['./text-container.component.scss'],
  hostDirectives: [DimensionsListenerDirective],
})
export class TextContainerComponent {
  outerStyles: Partial<CSSStyleDeclaration> = {};

  private readonly operator = inject(GAME_OPERATOR_TOKEN);
  private readonly game = inject(GAME_TOKEN);

  get gameData() {
    return this.operator.games.get(this.game);
  }

  get isAnswer() {
    return this.gameData.state.isAnswer;
  }

  get theme(): Theme {
    return this.operator.appearance.theme;
  }

  get isCorrect(): boolean | null {
    const lastRecord = this.gameData.history.last;
    if (!lastRecord) {
      return null;
    }
    return lastRecord.result.isCorrect;
  }

  @Input() restrictOverflow = false;

  constructor(
    private readonly _dimensionsListener: DimensionsListenerDirective,
    private readonly _cdr: ChangeDetectorRef,
  ) {
    this._dimensionsListener.sizeChanges.subscribe((res) => {
      this.adjust(res.width, res.height);
    });
  }

  adjust(width: number, height: number) {
    this.outerStyles = {
      fontSize: Math.min(width, height) * 0.0009 + 'px',
    };
    this._cdr.detectChanges();
  }
}
